import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import integration from 'src/mixins/integration';
import calendarIntegration from 'src/mixins/calendar-integration';
export default {
  name: 'CalendarConfigurationDialog',
  mixins: [dialog, integration, calendarIntegration],
  components: {
    TeDialog: TeDialog
  },
  props: {
    integration: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      step: 'configuration',
      calendars: null,
      loading: true,
      invalidAuthorization: false,
      selectedCalendar: this.integration.pivot ? this.integration.pivot.selected_calendar_id : null
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      switch (this.integration.integration_code) {
        case 'outlookcalendar':
          return this.$t('integrations.outlook_office_365');

        case 'googlecalendar':
          return this.$t('integrations.google_calendar');

        default:
          return '';
      }
    }
  },
  methods: {
    updateIntegration: function updateIntegration() {
      var _this = this;

      this.updateCalendar(this.integration.integration_code, this.selectedCalendar).then(function () {
        _this.$root.$emit('selected-calendar', _this.selectedCalendar);

        _this.$store.commit('app/setCalendarLoading', {
          calendar: _this.integration.integration_code,
          value: true
        });

        _this.step = 'completed';
      }).catch(function () {});
    },
    fetchIntegration: function fetchIntegration(integrationData) {
      this.integration = integrationData;
      this.fetchCalendars();
    },
    fetchCalendars: function fetchCalendars() {
      var _this2 = this;

      this.showLoading(this.$t('components.calendarConfigurationDialog.fetching_calendars'));
      return this.getCalendarList(this.integration.integration_code).then(function (result) {
        _this2.calendars = result;
      }).catch(function () {
        _this2.invalidAuthorization = true;
      }).finally(function () {
        _this2.loading = false;

        _this2.hideLoading();
      });
    },
    backToDashboard: function backToDashboard() {
      this.hide();

      if (!this.$route.path.includes('dashboard')) {
        this.$router.push('/dashboard');
      }
    },
    onConfigChange: function onConfigChange() {
      this.updateConfiguration(this.integration.integration_code, _objectSpread(_objectSpread({}, this.integration.pivot.configuration), {}, {
        syncPrivate: this.integration.pivot.configuration.syncPrivate,
        preSelectProjects: this.integration.pivot.configuration.preSelectProjects
      }));
    }
  },
  mounted: function mounted() {
    this.fetchCalendars();
  }
};